import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { IconChevronDown } from "../icons";
import "./labeledselect.scss";

const LabeledSelect = (props) => {
  const { label, selected, onOptionSelected, testid, options = [], mpngStyle = true } = props;

  const [optionsValues, setOptionsValues] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});

  const labeledSelectRef = useRef(null);

  useEffect(() => {
    if (mpngStyle && labeledSelectRef.current) {
      labeledSelectRef.current.style.setProperty("--labeled-select-active-color", "var(--mps-component-library-mpng-blue)");
    }
  }, [mpngStyle]);

  useEffect(() => {
    let items = options.filter((item) => {
      return item.id === selected;
    });
    if (items.length > 0) {
      setSelectedItem(items[0]);
    }
  }, [selected, options]);

  const handleChange = (value) => {
    const selectedOption = options.find((item) => item.id == value); // checked using == instead of === to ignore type matching because handleChange is returning string always
    if (selectedOption && !selectedOption.disabled) {
      onOptionSelected(value);
    }
  };

  const innerHtml = (
    <div {...(testid ? { "data-testid": testid } : {})} className="multi-range">
      <span className="multi-range-window">{label}</span>
      <br />
      <b>
        {selectedItem?.name && <span className="multi-range-label">{selectedItem.name}</span>}
      </b>
    </div>
  );

  useEffect(() => {
    const items = options.map((item) => {
      return (
        <Dropdown.Item
          className={`${item.disabled ? "disabled" : ""} ${item.id === selected ? "active" : ""}`}
          selected={true}
          key={item.id}
          eventKey={item.id}
          data-testid={`mpng-select-option-${item.name}`}
        >
          <span>{item.name}</span>
        </Dropdown.Item>
      );
    });
    setOptionsValues(items);
  }, [selected, options]);

  const CustomToggle = React.forwardRef(({ onClick, children }, ref) => (
    <>
      <Button
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
        data-testid="subject-selector-trigger"
        variant="outline-secondary"
        className="mpng-timeframe-button"
        arial-label="Timeframe selector"
      >
        {children}
      </Button>
      <IconChevronDown className="mpng-timeframe-button-icon" />
    </>
  ));

  return (
    <div
      style={props.style ? { ...props.style } : null}
      className={`${props.className || ""} mpng-labeled-selector `}
      data-testid="mpng-labeled-selector"
      ref={labeledSelectRef}
    >
      <Dropdown tabIndex={0} className="float-right" onSelect={handleChange}>
        <Dropdown.Toggle
          as={CustomToggle}
          variant="outline-secondary"
          className="mpng-timeframe-button mpng-header-button"
          aria-label="Select the timezone"
        >
          {innerHtml}
        </Dropdown.Toggle>
        <Dropdown.Menu role="listbox" className="listbox">
          {optionsValues}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LabeledSelect;
